export default "__VITE_ASSET__Bwdee3F7__"